export default function PlayButtonDefaultIcon() {
  return (
    <div className="play-button-default-white">
      <svg
        width="45"
        height="52"
        viewBox="0 0 45 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M45 26L-2.447e-06 51.9808L-1.75686e-07 0.0192356L45 26Z"
          fill="white"
        />
      </svg>
    </div>
  );
}
